import { useState, useRef, useEffect } from "react";
import { delay, motion } from "framer-motion";

import "../assets/css/home.css";

import { LuSquareMenu } from "react-icons/lu";
import { RiContactsFill, RiBuilding2Fill } from "react-icons/ri";
import {
  FaWhatsapp,
  FaFacebook,
  FaCity,
  FaHome,
  FaDraftingCompass,
  FaHardHat,
  FaWarehouse,
} from "react-icons/fa";
import { IoCloseSharp } from "react-icons/io5";
import { GiConcreteBag, GiHouse } from "react-icons/gi";
import { MdArchitecture } from "react-icons/md";

import SimpleCarousel from "../components/simple-carousel/simple-carousel";
import Ads from "../components/ads";
import Gallery from "../components/gallery";

import sendMessage from "../scripts/sendWaMessage";

import logo01 from "../assets/logos/simbolo oficial-01.png";
import hero0 from "../assets/images/hero/0.jpg";
import hero1 from "../assets/images/hero/1.jpg";
import hero2 from "../assets/images/hero/2.jpg";

import gallery0 from "../assets/images/gallery/0.png";
import gallery1 from "../assets/images/gallery/1.jpg";
import gallery2 from "../assets/images/gallery/2.jpg";
import gallery3 from "../assets/images/gallery/3.jpg";
import gallery4 from "../assets/images/gallery/4.jpg";
import gallery5 from "../assets/images/gallery/5.jpg";
import gallery6 from "../assets/images/gallery/6.jpg";
import gallery7 from "../assets/images/gallery/7.jpg";
import gallery8 from "../assets/images/gallery/8.jpg";
import gallery9 from "../assets/images/gallery/9.jpg";

import process0 from "../assets/images/process/0.jpg";
import process1 from "../assets/images/process/1.jpg";
import process2 from "../assets/images/process/2.jpg";
import process3 from "../assets/images/process/3.jpg";
import process4 from "../assets/images/process/4.jpg";

function Home({baseURL}) {
  const [menu, setMenu] = useState(false);

  const [contactBtn, setcontactBtn] = useState(false);

  const navMenu = useRef(null);

  function openNavMenu() {
    navMenu.current.showModal();
  }

  function closeNavMenu() {
    navMenu.current.close();
  }

  const AppearDown = {
    initial: { y: "100px", opacity: 0 },
    whileInView: { y: 0, opacity: 1 },
    transition: { duration: 1, delay: 0.2 },
  };
  const AppearUp = {
    initial: { y: "-100px", opacity: 0 },
    whileInView: { y: 100, opacity: 1 },
    transition: { duration: 1, delay: 0.2 },
  };
  const AppearLeft = {
    initial: { x: "-50%" },
    whileInView: { x: 0 },
    transition: { duration: 1, delay: 0.2 },
  };
  const AppearRight = {
    initial: { x: "50%" },
    whileInView: { x: 0 },
    transition: { duration: 1, delay: 0.2 },
  };

  return (
    <>
      <dialog ref={navMenu} className="nav-menu">
        <div>
          <IoCloseSharp onClick={() => closeNavMenu()} />
          <a href="#us" onClick={() => closeNavMenu()}>
            Nosotros
          </a>
          <a href="#services" onClick={() => closeNavMenu()}>
            Servicios
          </a>
          <a href="#commitment" onClick={() => closeNavMenu()}>
            Compromiso
          </a>
          <a href="#process" onClick={() => closeNavMenu()}>
            Proceso
          </a>
          <a href="#contact" onClick={() => closeNavMenu()}>
            Contacto
          </a>
          <a href="#gallery" onClick={() => closeNavMenu()}>
            Galería
          </a>
          <a href="#shop" onClick={() => closeNavMenu()}>
            Mercado
          </a>
        </div>
      </dialog>

      <motion.div
        className="contact-button-section"
        initial={{ y: "100%", opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 1, delay: 1 }}
      >
        <div style={{ display: contactBtn ? "" : "none" }}>
          <button className="sub-btn">
            <a
              href="https://www.facebook.com/profile.php?id=61578204662851"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebook />
            </a>
          </button>
          <button className="sub-btn">
            <a
              href="https://wa.me/+523315741580"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaWhatsapp />
            </a>
          </button>
        </div>
        <button>
          <RiContactsFill onClick={() => setcontactBtn(!contactBtn)} />
        </button>
      </motion.div>

      <motion.div
        id="hero"
        class="hero"
        initial={{ x: "100%" }}
        animate={{ x: 0 }}
        transition={{ duration: 1 }}
      >
        <div class="hero-carousel">
          <img src={hero0} alt="imagen 1" />
          <img src={hero1} alt="imagen 2" />
          <img src={hero2} alt="imagen 3" />
          <img src={hero0} alt="imagen 1" />
        </div>
        <div class="overlay"></div>
        <br />
        <nav>
          <motion.img
            src={logo01}
            alt="logo"
            draggable={false}
            {...AppearLeft}
            transition={{ delay: 2 }}
          />
          <div>
            <div style={{ display: menu ? "" : "none" }}>
              <p>Nosotros</p>
              <p>Servicios</p>
              <p>Compromiso</p>
              <p>Proceso</p>
              <p>Contacto</p>
              <p>Galería</p>
              <p>Mercado</p>
            </div>
            <motion.div {...AppearRight} transition={{ delay: 1 }}>
              <LuSquareMenu onClick={() => openNavMenu()} />
            </motion.div>
          </div>
        </nav>
        <motion.div
          initial={{ y: "100%", opacity: 0 }}
          animate={{ y: -100, opacity: 1 }}
          transition={{ duration: 1, delay: 1.5 }}
          className="hero-content"
        >
          <h1>Desarrollos Arquitectónicos</h1>
          <p>TU VISIÓN, NUESTRA EXPERIENCIA</p>
          <a href="#us">
            <button>Conoce más</button>
          </a>
        </motion.div>
      </motion.div>

      <hr />

      <section className="section" id="us">
        <motion.div {...AppearLeft} transition={{ delay: 0.2 }}>
          <h2>Nosotros</h2>
          <p>MDA Desarrollos Arquitectónicos</p>
          <p className="text">
            Somos una empresa con más de 10 años de experiencia siempre con el
            objetivo de dar una solución integral, puntual y profesional a cada
            proyecto mediante un equipo especializado de arquitectos e
            ingenieros, comprometidos con el desarrollo de soluciones
            constructivas, sostenibles e innovadoras.
          </p>
          <div className="us-list">
            <li>
              <b>Diseño Arquitectónico </b> <br />
              Proyecto personalizado, con el objetivo de cubrir las necesidades
              de diseño, necesidades y presupuesto de cada cliente.
            </li>
            <li>
              <b>Construcción </b> <br />
              Los mejores profesionales de la construcción siempre garantizando
              la mejor calidad en mano de obra calificada, materiales y el mejor
              proceso constructivo.
            </li>
            <li>
              <b>Control y Administración de Obra </b> <br />
              Administración de los recursos humanos y materiales para lograr la
              mejor construcción y calidad dentro del presupuesto establecido.
            </li>
            <li>
              <b>Proyectos Integrales (llave en mano) </b> <br />
              Proyecto y construcción de tu casa en tiempo y forma solo para que
              tú la habites.
            </li>
          </div>
        </motion.div>
        <motion.div {...AppearRight} transition={{ delay: 0.3 }}>
          <div className="simple-carousel"></div>
        </motion.div>
      </section>

      <section className="section" id="services">
        <h2>Nuestros Servicios</h2>
        <p className="section-desc">
          Los especialistas en cada etapa: de la concepción al cierre de obra.
        </p>
        <div className="card-div">
          <motion.div className="card" {...AppearDown}>
            <GiConcreteBag />
            <p>ESTRUCTURAS DE CONCRETO ARMADO</p>
          </motion.div>

          <motion.div className="card" {...AppearDown}>
            <FaHardHat />
            <p>CONSTRUCCIÓN Y REMODELACIÓN</p>
          </motion.div>

          <motion.div className="card" {...AppearDown}>
            <FaCity />
            <p>DISEÑO URBANO E INFRAESTRUCTURA</p>
          </motion.div>

          <motion.div className="card" {...AppearDown}>
            <FaWarehouse />
            <p>LOCALES COMERCIALES</p>
          </motion.div>

          <motion.div className="card" {...AppearDown}>
            <RiBuilding2Fill />
            <p>EDIFICACIÓN VERTICAL</p>
          </motion.div>

          <motion.div className="card" {...AppearDown}>
            <FaHome />
            <p>CASA HABITACIÓN</p>
          </motion.div>

          <motion.div className="card" {...AppearDown}>
            <MdArchitecture />
            <p>ELABORACIÓN DE PROYECTOS ARQUITECTÓNICOS INTEGRALES</p>
          </motion.div>
        </div>
      </section>

      <section className="section" id="commitment">
        <h2>Compromiso</h2>
        <p className="section-desc">
          Nuestro compromiso es tu tranquilidad y la excelencia en cada etapa.
        </p>
        <div>
          <motion.div className="comm1" {...AppearDown}></motion.div>
          <motion.div className="comm2" {...AppearDown}></motion.div>
          <motion.div className="comm3" {...AppearDown}></motion.div>
        </div>
      </section>

      <section className="section" id="process">
        <h2>Proceso</h2>
        <a
          href="https://www.freepik.es"
          target="blank"
          rel="noopener noreferrer"
          className="freepik-p"
        >
          Images by Freepik
        </a>
        <p className="section-desc">
          Conoce las etapas que seguimos para materializar tu proyecto.
        </p>
        <div>
          <motion.div {...AppearRight} className="process-step">
            <div>
              <h3>Detección de Necesidades</h3>
              <p>
                Por medio de una entrevista, se exponen y analizan las
                necesidades requeridas.
              </p>
            </div>
            <div>
              <img src={process0} alt="paso-img" />
            </div>
          </motion.div>
          <motion.div {...AppearLeft} className="process-step">
            <div>
              <h3>Anteproyecto</h3>
              <p>
                Se comienza con la elaboración de estudios y propuestas para
                resolver las necesidades.
              </p>
            </div>
            <div>
              <img src={process1} alt="paso-img" />
            </div>
          </motion.div>
          <motion.div {...AppearRight} className="process-step">
            <div>
              <h3>Proyecto Ejecutivo y Visualización</h3>
              <p>
                Autorizando la propuesta, se realiza el proyecto ejecutivo y
                renders necesarios para la construcción.
              </p>
            </div>
            <div>
              <img src={process2} alt="paso-img" />
            </div>
          </motion.div>
          <motion.div {...AppearLeft} className="process-step">
            <div>
              <h3>Presupuesto</h3>
              <p>
                Se presenta la propuesta económica desglosada por cada etapa de
                construcción. Asi como el programa de obra para determinar el
                tiempo de ejecución de obra y firmar contrato.
              </p>
            </div>
            <div>
              <img src={process3} alt="paso-img" />
            </div>
          </motion.div>
          <motion.div {...AppearRight} className="process-step">
            <div>
              <h3>Ejecución de Obra</h3>
              <p>
                Autorizado el presupuesto se comienza con la etapa de ejecución
                de obra.
              </p>
            </div>
            <div>
              <img src={process4} alt="paso-img" />
            </div>
          </motion.div>
        </div>
      </section>

      <section className="section" id="contact">
        <h2>Contacto</h2>

        <div className="contact-section__container">
          <motion.aside {...AppearLeft} className="contact-section__info-map">
            <div className="contact-info">
              <p>Llámanos, escríbenos o visítanos.</p>
              <ul className="contact-info__list">
                <li>
                  <span className="icon">📞</span>
                  <a href="tel:+523315741580">(+52) 331 5741 580</a>
                </li>
                <li style={{ display: "none" }}>
                  <span className="icon">✉️</span>
                  <a href="mailto:contacto@correo.com">contacto@correo.com</a>
                </li>
                <li>
                  <span className="icon">📍</span>
                  <span>Av. De los Deportes 4924, Zapopan, Jal.</span>
                </li>
              </ul>
            </div>
            <iframe
              className="contact-section__iframe"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3731.478501621397!2d-103.34896422590894!3d20.731390997927992!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8428b03cb9bb11bf%3A0xb27d986fffe4559e!2sAv.%20de%20los%20Deportes%204924%2C%20Auditorio%2C%2045180%20Zapopan%2C%20Jal.!5e0!3m2!1ses!2smx!4v1751485975040!5m2!1ses!2smx"
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Mapa de ubicación"
            />
          </motion.aside>

          <motion.section {...AppearRight} className="contact-section__form">
            <div className="contact-form__header">
              <p>Iniciemos hoy tu proyecto, ¡contáctanos!</p>
              <small>Respondemos de Lunes a Sábado</small>
            </div>
            <form className="contact-form" onSubmit={sendMessage}>
              <input
                type="text"
                placeholder="Nombre(s) y Apellido(s)*"
                name="userName"
                required
              />
              <input
                type="email"
                placeholder="E-Mail*"
                name="contact"
                required
              />
              <textarea
                placeholder="Escribe tu mensaje..."
                name="message"
                rows={4}
              />
              <button type="submit">Enviar</button>
            </form>
          </motion.section>
        </div>
      </section>

      <section className="section" id="gallery">
        <h2>Galería</h2>
        <p className="section-desc">Conoce nuestra galería.</p>
        <Gallery baseURL={baseURL}/>
        
      </section>

      <section className="section" id="shop">
        <h2>Mercado</h2>
        <p className="section-desc">
          Explora nuestras soluciones arquitectónicas llave en mano.
        </p>
        <Ads baseURL={baseURL} />
      </section>

      <footer className="footer">
        <div className="footer-content">
          <div className="footer-logo">
            <h3>MDA</h3>
            <p>TIENES EL CONCEPTO VAMOS A LA CREACION ¡CONTACTANOS!</p>
          </div>

          <div className="footer-links">
            <h4>Enlaces</h4>
            <ul>
              <li>
                <a href="#hero">Inicio</a>
              </li>
              <li>
                <a href="#us">Nosotros</a>
              </li>
              <li>
                <a href="#contact">Ubicación</a>
              </li>
            </ul>
          </div>

          <div className="footer-social">
            <h4>Conéctate</h4>
            <div className="social-icons">
              <a
                href="https://www.facebook.com/profile.php?id=100065312767948"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebook />
              </a>
              <a
                href="https://wa.me/+523315741580"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaWhatsapp />
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <a
            href="https://bsitescomp.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            © 2025 Sitio desarrollado por <b>B-Sites.</b>
          </a>
        </div>
      </footer>
    </>
  );
}

export default Home;
